import { Row } from "@tanstack/react-table";

import { Button } from "@/components/ui/button/button";

import { Announcement } from "./schema";
import { useViewModal } from "../view-announcement-modal/use-view-modal";
import { useDeleteAnnouncementModal } from "../delete-announcement-modal/use-delete-announcement-modal";
import { Trash } from "lucide-react";

interface DataTableRowActionsProps<TData> {
  row: Row<TData>;
}

export function DataTableRowActions<TData>({
  row,
}: DataTableRowActionsProps<TData>) {
  const originData = row.original as Announcement;

  const { onOpenChange: onViewModalChange, setAnnouncement } = useViewModal();
  const { onOpenChange, setAnnouncementId } = useDeleteAnnouncementModal();

  return (
    <div className="flex items-center gap-4">
      <Button
        size="sm"
        variant="default"
        onClick={() => {
          setAnnouncement(originData);
          onViewModalChange(true);
        }}
      >
        View
      </Button>

      <Button
        size="icon"
        variant="destructive"
        className="w-6 h-6"
        onClick={() => {
          setAnnouncementId(originData?.id);
          onOpenChange(true);
        }}
      >
        <Trash className="w-4 h-4" />
      </Button>
    </div>
    // <DropdownMenu open={open} onOpenChange={setOpen}>
    //   <DropdownMenuTrigger asChild>
    //     <Button
    //       variant="ghost"
    //       className="flex h-8 w-8 p-0 data-[state=open]:bg-muted"
    //     >
    //       <DotsHorizontalIcon className="h-4 w-4" />
    //       <span className="sr-only">Open menu</span>
    //     </Button>
    //   </DropdownMenuTrigger>
    //   <DropdownMenuContent align="end" className="w-[160px]">
    //     {authData?.user?.permissions?.["2"]?.includes("LeaveApplication") && (
    //       <DropdownMenuItem
    //         onMouseDown={() => {
    //           setLeaveId(originData?.id);
    //           onOpenChange(true);
    //           setOpen(false);
    //         }}
    //       >
    //         Take Action
    //       </DropdownMenuItem>
    //     )}
    //     <DropdownMenuItem
    //       onMouseDown={() => {
    //         setLeaveApplication(originData);
    //         onViewModalChange(true);
    //         setOpen(false);
    //       }}
    //     >
    //       View
    //     </DropdownMenuItem>
    //   </DropdownMenuContent>
    // </DropdownMenu>
  );
}
